export const AUTH_USER = "auth_user";
export const AUTH_ERROR = "auth_error";
export const USER_PROFILE = "user_profile";
export const SEARCH_USERS = "search_users";
export const UPDATE_PROFILE = "update_profile";
export const UPDATE_PROFILE_IMG = "update_profile_img";